import { MetaDefinition } from '@angular/platform-browser';

export const getMetaTitleTags = (title: string): MetaDefinition[] => {
  if (title === undefined) return [];
  return [
    { property: 'og:title', content: title },
    { name: 'twitter:title', content: title },
  ];
};
export const getMetaDescriptionTags = (description: string): MetaDefinition[] => {
  if (description === undefined) return [];
  return [
    { name: 'description', content: description },
    { property: 'og:description', content: description },
    { name: 'twitter:description', content: description },
  ];
};

export const getMetaImageTags = (imageUrl: string): MetaDefinition[] => {
  if (imageUrl === undefined) return [];
  return [
    {
      property: 'og:image',
      content: imageUrl,
    },
    {
      name: 'twitter:image',
      content: imageUrl,
    },
  ];
};

export const noIndexMetaTag = { name: 'robots', content: 'noindex, nofollow' };
export const doIndexMetaTag = {
  name: 'robots',
  content: 'index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large',
};
